// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2137 ? "b02083d2" : chunkId) + "." + {"128":"5e5693da1455f589","1982":"14347144802de052","2137":"863d5ebf9039afbe","6241":"481f163abcc0d2f5","7911":"7bd8d978cfee7d84","8680":"c5cc18f8b86af432"}[chunkId] + ".js";
};